export default __webpack_public_path__ + "media/nodejs.8e341cc0.png";